(function () {
  var currentMode = "single";

  function setMode(mode) {
    currentMode = mode === "double" ? "double" : "single";
    var multiplier = currentMode === "double" ? 2 : 1;
    var roots = Array.prototype.slice.call(document.querySelectorAll("[data-kvsche-skyline-spec]"));

    roots.forEach(function (root) {
      root.setAttribute("data-current-skyline", currentMode);
    });

    roots.forEach(function (root) {
      root.querySelectorAll("[data-product-toggle]").forEach(function (button) {
        var active = button.getAttribute("data-product-toggle") === currentMode;
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });

      root.querySelectorAll("[data-skyline-single][data-skyline-double]").forEach(function (item) {
        item.textContent = item.getAttribute(currentMode === "double" ? "data-skyline-double" : "data-skyline-single");
      });

      root.querySelectorAll("[data-skyline-variant]").forEach(function (item) {
        item.toggleAttribute("hidden", item.getAttribute("data-skyline-variant") !== currentMode);
      });

      root.querySelectorAll("[data-skyline-image]").forEach(function (item) {
        item.toggleAttribute("hidden", item.getAttribute("data-skyline-image") !== currentMode);
      });

      root.querySelectorAll("[data-bottle-row]").forEach(function (item) {
        var rows = Number(item.getAttribute("data-bottle-row"));
        if (!Number.isNaN(rows)) {
          item.textContent = rows + " Rows/ " + rows * multiplier + " Bottles";
        }
      });
    });
  }

  function bindToggles(scope) {
    (scope || document).querySelectorAll("[data-product-toggle]").forEach(function (button) {
      if (button.getAttribute("data-kvsche-bound") === "true") return;
      button.setAttribute("data-kvsche-bound", "true");
      button.addEventListener("click", function () {
        setMode(button.getAttribute("data-product-toggle"));
      });
    });
    setMode(currentMode);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bindToggles(document);
    });
  } else {
    bindToggles(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    bindToggles(event.target);
  });
})();
